import React from "react";
import { Modal, ModalHeader } from "../../../globalComponents/ui/Modal";
import { KpiModal, ModalHeader as KpiModalHeader } from "../Quantative/component/KpiIcons";

const isImage = (mime = "", url = "") => mime.startsWith("image/") || /\.(png|jpe?g|gif|webp)$/i.test(url);
const isPdf = (mime = "", url = "") => mime === "application/pdf" || /\.pdf$/i.test(url);

/**
 * Expandable document preview, shared by MultiDocumentUploadField (attach
 * flow), DocumentViewerPanel (read-only answer view) and the qualitative
 * document modals — opens the file full-size in a modal instead of a small
 * inline strip.
 *
 * `document` shape: { fileName?, fileMetadata: { url, mimeType, fileName } }
 *
 * `variant="kpi"` renders with KpiModal/KpiIcons' ModalHeader instead of the
 * globalComponents one, so the preview visually matches when it's opened from
 * on top of a KpiModal-based parent (e.g. the qualitative Add Data / View
 * Documents modals) rather than clashing with a different modal chrome.
 */
const DocumentPreviewModal = ({ document: doc, onClose, variant = "default" }) => {
  if (!doc) return null;
  const fileMeta = doc.fileMetadata || {};
  const url = fileMeta.url || "";
  const mime = fileMeta.mimeType || "";
  const name = fileMeta.fileName || doc.fileName || "Document";
  const isKpi = variant === "kpi";

  const body = (
    <>
      <div style={{ padding: 20 }}>
        {isImage(mime, url) ? (
          <img
            src={url}
            alt={name}
            style={{ maxWidth: "100%", maxHeight: "70vh", display: "block", margin: "0 auto", borderRadius: 8, border: "1px solid var(--rule, #e2e8f0)" }}
          />
        ) : isPdf(mime, url) ? (
          <iframe
            src={url}
            title={name}
            style={{ width: "100%", height: "70vh", border: "1px solid var(--rule, #e2e8f0)", borderRadius: 8 }}
          />
        ) : (
          <div style={{ padding: 24, textAlign: "center", background: "#f8fafc", borderRadius: 8, color: "#64748b", fontSize: 13 }}>
            No inline preview for this file type.
            {url && (
              <>
                {" "}
                <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: "#3f88a5", fontWeight: 600 }}>
                  Download file ↗
                </a>
              </>
            )}
          </div>
        )}
      </div>
      <div style={{ padding: "12px 20px 16px", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "flex-end", gap: 8 }}>
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ padding: "8px 16px", borderRadius: 8, border: "1.5px solid #e2e8f0", color: "#334155", fontSize: 13, fontWeight: 600, textDecoration: "none" }}
          >
            Open in new tab ↗
          </a>
        )}
        <button
          onClick={onClose}
          style={{ padding: "8px 16px", borderRadius: 8, border: "none", background: "#3f88a5", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}
        >
          Close
        </button>
      </div>
    </>
  );

  if (isKpi) {
    return (
      <KpiModal show maxWidth={760} onClose={onClose}>
        <KpiModalHeader icon="search" title={name} onClose={onClose} />
        {body}
      </KpiModal>
    );
  }

  return (
    <Modal show maxWidth={760} onClose={onClose}>
      <ModalHeader icon="fas fa-eye" title={name} onClose={onClose} />
      {body}
    </Modal>
  );
};

export default DocumentPreviewModal;
